import { render, staticRenderFns } from "./psa-hub-main-tab.vue?vue&type=template&id=3643a081&scoped=true&"
import script from "./psa-hub-main-tab.vue?vue&type=script&lang=tsx&"
export * from "./psa-hub-main-tab.vue?vue&type=script&lang=tsx&"
import style0 from "./psa-hub-main-tab.vue?vue&type=style&index=0&id=3643a081&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3643a081",
  null
  
)

export default component.exports